import {
  ACTION,
  MAX_RENDER_STYLES,
  MODE,
  MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.NANO_BANANA_RENDER_3D_TO_2D_NB2_LITE,
  "provider": PROVIDER.NANO_BANANA,
  "action": ACTION.RENDER,
  "mode": MODE.NB2_LITE,
  // The backend rejects a run whose run_type differs from the catalog's.
  "run_type": "image_generation",
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      // A screenshot of the viewer, captured and uploaded per click by GenerateButton
      // rather than held in the form, so it is written into canonical_params after the build.
      // The first item carries role "object" (the 3-D render); any additional items are
      // style references with role "style". Exactly-one-object is enforced server-side.
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1 + MAX_RENDER_STYLES,
        "items": {
          "type": "object",
          "properties": {
            "asset_id": { "type": "integer" },
            "role": { "type": "string", "enum": ["object", "style"] },
          },
          "required": ["asset_id", "role"],
        },
      },
      "creativity": {
        "type": "number",
        "minimum": 0,
        "maximum": 1,
        "default": 0.5,
      },
    },
    // The backend requires prompt and input_image, but neither lives where
    // useAreRequiredParamsFulfilled looks: the Render tab gates the prompt itself and
    // the image only exists once the button is clicked.
    "required": [],
  },
  "ui_schema": {},
}
